import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { CurrentLocale, En, Ru, LocaleWrraper, LocaleList, NewLocale, LocaleName } from './elements';

export const LocaleContainer = ({ t, pageContext }) => {

    return (
        <LocaleWrraper>
            <CurrentLocale>
                {pageContext.lang === 'en' && <En />}
                {pageContext.lang === 'ru' && <Ru />}
            </CurrentLocale>
            <LocaleList>
                <NewLocale to={pageContext.originalPath}>
                    <En />
                    <LocaleName>{t("en")}</LocaleName>
                </NewLocale>
                <NewLocale to={`/ru${pageContext.originalPath}`}>
                    <Ru />
                    <LocaleName>{t("ru")}</LocaleName>
                </NewLocale>
            </LocaleList>
        </LocaleWrraper>
    );
};

export const Locale = withTrans(LocaleContainer);